
import { api } from "../../helpers/api";
import { chunk, na } from "../../helpers/functions";

export default {
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      perPage: 12,
      pages: 0,
      loading: false,
    };
  },
  computed: {
    chunks() {
      return chunk(this.list, 4);
    },
  },
  created() {
    this.fetchArticles(1, 12);
  },
  methods: {
    fetchArticles(page, pageSize = 20) {
      this.loading = true;
      api()
        .get(
          `/news?page=${page}&per-page=${pageSize}&expand=local,categories,categories.local,url`
        )
        .then(({ data, header }) => {
          this.list = [...this.list, ...data];
          this.total = parseInt(header("x-pagination-total-count")) ?? 0;
          this.page = parseInt(header("x-pagination-current-page")) ?? 1;
          this.perPage = parseInt(header("x-pagination-per-page")) ?? 1;
          this.pages = parseInt(header("x-pagination-page-count")) ?? 0;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    category(content) {
      const newsId = parseInt($(`#${this.appCategory}`).data("news"));
      return content.categories.find(
        (item) => item.id !== newsId && item.parent_id === newsId
      );
    },
    categoryName(content) {
      const category = this.category(content);
      return category && category.local && category.local.name
        ? category.local.name
        : na();
    },
    categoryIcon(content) {
      const category = this.category(content);
      return category &&
        category.attrs &&
        category.attrs.news_area_icon &&
        category.attrs.news_area_icon.url
        ? category.attrs.news_area_icon.url
        : "";
    },
    date(content) {
      const d = new Date(content.attrs?.news_date || null);
      const ye = new Intl.DateTimeFormat("en", {
        year: "numeric",
      }).format(d);
      const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
      const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
      return `${da} ${mo} ${ye}`;
    },
  },
};
